export default __webpack_public_path__ + "static/oraclecpq-ef0bb0c84908429ede4eabbdb6f1997d.svg";